import { WidgetToolboxState } from './state';
import { ReduxAction } from '../actions';
import { UPDATE_WIDGET_TOOLBOX_WIDGETS } from './constants';

const INITIAL_STATE: WidgetToolboxState = {
  forPage: {}, // widgets[] by pagePath
};

export const WidgetToolbox = (
  state: WidgetToolboxState = INITIAL_STATE,
  action: ReduxAction
): WidgetToolboxState => {
  switch (action.type) {
    case UPDATE_WIDGET_TOOLBOX_WIDGETS: {
      const { pagePath, widgets } = action;

      const widgetsSorted = [...widgets].sort((a, b): number =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );

      return {
        ...state,
        forPage: {
          ...state.forPage,
          [pagePath]: widgetsSorted,
        },
      };
    }
    default:
      return state;
  }
};
